import { Space, Select } from 'antd';
import { useStandard } from '../../hook/useHook';

export default function index(props) {
    const { dictName, getVersion, searchVal, setSearchVal } = useStandard()
    return (
        <Space style={{ marginBottom: 20 }}>
            <div>{dictName}</div>
            <Select
                value={searchVal.versionId}
                fieldNames={{ label: "version", value: "dictId" }}
                options={getVersion?.data}
                style={{ width: 300 }}
                onChange={(val) => {
                    setSearchVal(prev => ({ ...prev, versionId: val }))
                }}
            />
        </Space>
    );
}
